"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CollectionManager {
    constructor(eventManager, collectionByNames = {}) {
        this._eventManager = eventManager;
        this._collectionsByName = {};
        for (const collectionName in collectionByNames) {
            this.add(collectionName, collectionByNames[collectionName], false);
        }
    }
    // TODO Some code path don't have event managers, like tasks, so this can be undefined. There should always be one, event if it doesn't do anything with events
    getEventManager() {
        return this._eventManager || undefined;
    }
    add(collectionName, collection, refresh = true) {
        this.update(collectionName, collection, refresh);
    }
    set(collectionName, collection, refresh = true) {
        this.update(collectionName, collection, refresh);
    }
    update(collectionName, collection, refresh = true) {
        this._collectionsByName[collectionName] = collection;
        if (refresh) {
            this.refresh(collectionName);
        }
    }
    remove(collectionName, refresh = true) {
        delete this._collectionsByName[collectionName];
        if (refresh) {
            this.refresh(collectionName);
        }
    }
    has(collectionName) {
        return collectionName in this._collectionsByName;
    }
    hasCollection(collectionName // alias of has (still in use)
    ) {
        return this.has(collectionName);
    }
    getNames() {
        return Object.keys(this._collectionsByName);
    }
    getCollectionNames() {
        // alias of getNames (still in use)
        return this.getNames();
    }
    get(collectionName) {
        return this._collectionsByName[collectionName];
    }
    getCollection(collectionName) {
        // alias of get (still in use)
        return this.get(collectionName);
    }
    getSize() {
        return Object.keys(this._collectionsByName).length;
    }
    refresh(collectionName) {
        if (this._eventManager) {
            this._eventManager.emit(`collection.update.${collectionName}`);
            this._eventManager.emit('collections.update');
        }
    }
}
exports.default = CollectionManager;
//# sourceMappingURL=CollectionManager.js.map